import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'ghost' | 'danger' | 'tactical';
  className?: string;
}

const VARIANT_CLASSES: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary:
    'bg-[var(--color-accent)] text-[var(--color-text-display)] hover:bg-[var(--color-accent-hover)] active:bg-[var(--color-accent-pressed)] shadow-sm',
  ghost:
    'bg-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-elevated)] border border-[var(--color-border)] hover:border-[var(--color-border-subtle)]',
  danger:
    'bg-transparent text-red-400 hover:bg-red-950/40 border border-red-800/50 hover:border-red-700',
  tactical:
    'bg-ember-500 text-white shadow-ember border-t-[0.5px] border-ember-400/20 rounded-lg active:opacity-90',
};

export function Button({
  children,
  type = 'button',
  variant = 'primary',
  className = '',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      data-variant={variant}
      className={`inline-flex items-center justify-center px-4 py-2.5 rounded-md text-body-sm font-medium transition-colors duration-100 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-bg)] ${VARIANT_CLASSES[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
